import { render } from "./CommentBox.vue?vue&type=template&id=7e2ca8c4&scoped=true&ts=true"
import script from "./CommentBox.vue?vue&type=script&lang=ts"
export * from "./CommentBox.vue?vue&type=script&lang=ts"

import "./CommentBox.vue?vue&type=style&index=0&id=7e2ca8c4&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e2ca8c4"]])

export default __exports__